export function validateEmailDetailed(email) {
    if (!email) return "Email is required.";
  
    const atCount = (email.match(/@/g) || []).length;
    if (atCount !== 1) return "Email must contain exactly one @ symbol.";
  
    const [local, domain] = email.split("@");
  
    // Local part rules
    if (local.length === 0) return "Text before @ is empty.";
    if (local.length > 64) return "Text before @ must be 64 characters or fewer.";
    if (local.startsWith(".") || local.endsWith(".")) return "Text before @ cannot start or end with a dot.";
    if (local.includes("..")) return "Text before @ cannot contain consecutive dots.";
    if (!/^[A-Za-z0-9._+-]+$/.test(local)) {
      return "Text before @ has invalid characters.";
    }
  
    // Domain rules
    if (!domain) return "Domain after @ is missing.";
    if (!domain.includes(".")) return "Domain must contain a dot (e.g., example.com).";
    const labels = domain.split(".");
    for (const label of labels) {
      if (label.length === 0) return "Domain has an empty label.";
      if (label.length > 63) return "A domain label is longer than 63 characters.";
      if (!/^[A-Za-z0-9-]+$/.test(label)) return "Domain labels can only use letters, digits, and hyphens.";
      if (label.startsWith("-") || label.endsWith("-")) return "Domain labels cannot start or end with a hyphen.";
    }
  
    const tld = labels[labels.length - 1];
    if (tld.length < 2) return "Top-level domain must be at least 2 characters.";
  
    if (email.length > 254) return "Email address is too long (max 254 characters).";
  
    return ""; // valid
  }
  

/**
 * Rule checks aligned with toc-user-backend `ValidationUtils.validatePassword`
 * (8+ chars, lowercase, uppercase, digit, special character).
 */
export function getPasswordRuleChecks(password) {
  const pwd = password ?? "";
  const rules = [
    { id: "len", label: "At least 8 characters", met: pwd.length >= 8 },
    { id: "lower", label: "At least one lowercase letter", met: /[a-z]/.test(pwd) },
    { id: "upper", label: "At least one uppercase letter", met: /[A-Z]/.test(pwd) },
    { id: "num", label: "At least one number", met: /\d/.test(pwd) },
    {
      id: "special",
      label: "At least one special character (e.g. !@#$%)",
      met: /[^A-Za-z0-9]/.test(pwd),
    },
  ];
  const metCount = rules.filter((r) => r.met).length;
  const strengthPercent = Math.round((metCount / rules.length) * 100);
  const allMet = metCount === rules.length;
  return { rules, metCount, strengthPercent, allMet };
}

/** Registration / reset password: must satisfy all backend rules. */
export function validateRegistrationPassword(password) {
  if (!password) return "Password is required.";
  const { allMet } = getPasswordRuleChecks(password);
  if (!allMet) {
    return "Please satisfy all password requirements below.";
  }
  if (password.length > 128) {
    return "Password is too long.";
  }
  return "";
}

/** Same rules as registration (used by reset-password flow, etc.). */
export function validatePassword(password) {
  return validateRegistrationPassword(password);
}
  